import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useOfferHistory = (offerId: string) => {
    return useQuery(queries.offers.detail(offerId)._ctx.history);
};
